import { render, staticRenderFns } from "./bidding.vue?vue&type=template&id=0244907c&"
import script from "./bidding.vue?vue&type=script&lang=js&"
export * from "./bidding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports